<script>
  export let selected = false;
</script>

<div class="selection-overlay" aria-hidden="true"></div>

<div class="selection-check" aria-hidden="true">
  {#if selected}
    <div class="selection-check__dot"></div>
  {/if}
</div>

<style>
  .selection-overlay {
    position: absolute;
    inset: 0;
    z-index: 10;
    border-radius: 1rem;
    background: rgba(59, 130, 246, 0.1);
    pointer-events: none;
  }

  .selection-check {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    height: 1.25rem;
    border: 1px solid #3b82f6;
    border-radius: 999px;
    background: #fff;
    pointer-events: none;
  }

  .selection-check__dot {
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 999px;
    background: #3b82f6;
  }
</style>
